/**
 * èåæ¥è¯¢åæ°
 *
 */
export class UnionQueryPara {
  formCode: string;
  columns: DynamicShowColumn[];
  request: QueryListRequest;
}

/**
 * å¨ææ¥è¯¢å
 *
 */
export class DynamicSelectColumn {
  /**
   * å®ä½ç¼ç 
   *
   * @memberof DynamicSelectColumn
   */
  entityCode: string;

  /**
   * å®ä½åç§°
   *
   * @memberof DynamicSelectColumn
   */
  attributeName: string;

  /**
   * æ°æ®ç±»å
   *
   * @memberof DynamicSelectColumn
   */
  dataType?: string;
}

/**
 * å¨æå±ç¤ºå
 *
 */
export class DynamicShowColumn {
  /**
   * å®ä½ç¼ç 
   *
   * @memberof DynamicSelectColumn
   */
  entityCode: string;

  /**
   * å®ä½åç§°
   *
   * @memberof DynamicSelectColumn
   */
  attributeName: string;
}

export class QueryListRequest {
  filter: DynamicFormQueryGroup;
  sort: DynamicFormPagingSort[];
  pageSize: number;
  pageIndex: number;
}

export class DynamicFormQueryGroup {
  op: string;
  groups: DynamicFormQueryGroup[];
  rules: DynamicFormRule[];
}

export class DynamicFormRule {
  field: string;
  op: string;
  type: string;
  data: any;
  datas?: Array<any>;
  isDynamic: boolean;
  prefix?: string;
}

export class DynamicFormPagingSort {
  field: string;
  sort: string;
  isDynamic: boolean;
}
